import React from 'react';
import Drawer from 'material-ui/Drawer';
import AppBar from 'material-ui/AppBar';
import {ListItem} from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import {closeDrawer} from "../../actions/shared/actions_shared_1";
import {connect} from "react-redux";
import ActionEventSeatIcon from "material-ui/svg-icons/action/event-seat";
import HomeIcon from "material-ui/svg-icons/action/home";
import AccountCircleIcon from "material-ui/svg-icons/action/account-circle";
import ProjetProIcon from 'material-ui/svg-icons/action/work';
import EntretiensIcon from 'material-ui/svg-icons/action/group-work';
import FormationsIcon from 'material-ui/svg-icons/social/school';
import PlansActionIcon from 'material-ui/svg-icons/av/playlist-add-check';
import BibCompetencesIcon from "material-ui/svg-icons/content/archive";


class SalarieDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.handleNestedListToggle = this.handleNestedListToggle.bind(this);
    }

    handleNestedListToggle(element) {
        element.open = !element.open;
    }

    render() {
        return (
            <div>
                <Drawer
                    open={this.props.open}
                    docked={false}
                    onRequestChange={() => this.props.dispatch(closeDrawer())}
                >
                    <AppBar
                        iconElementRight={<IconButton><NavigationClose/></IconButton>}
                        onRightIconButtonClick={() => this.props.dispatch(closeDrawer())}
                    />
                    <ListItem
                        key={1}
                        primaryText="Accueil "
                        onClick={() => this.props.history.push('/salarie')}
                        leftIcon={<HomeIcon/>}
                    />
                    <ListItem
                        key={2}
                        primaryText="Informations personnelles"
                        onClick={() => this.props.history.push('/salarie/infos-personnelles')}
                        leftIcon={<AccountCircleIcon/>}
                    />
                    <ListItem
                        key={3}
                        primaryText="Formations"
                        onClick={() => this.props.history.push('/salarie/formations')}
                        leftIcon={<FormationsIcon/>}
                    />

                    <ListItem
                        key={4}
                        primaryText="Entretiens"
                        onClick={() => this.props.history.push('/salarie/entretiens')}
                        leftIcon={<EntretiensIcon/>}
                    />
                    <ListItem
                        key={5}
                        primaryText="Projet professionnel"
                        onClick={() => this.props.history.push('/salarie/projet-pro')}
                        leftIcon={<ProjetProIcon/>}
                    />
                    <ListItem
                        key={6}
                        primaryText="Plans d'action"
                        onClick={() => this.props.history.push('/salarie/plans-action')}
                        leftIcon={<PlansActionIcon/>}
                    />
                    <ListItem key={7}
                              primaryText="Bibliotheque des compétences"
                              onClick={() => this.props.history.push('/salarie/bibliotheque-des-competences')}
                              leftIcon={<BibCompetencesIcon/>}
                    />
                    <ListItem
                        key={8}
                        primaryText="Postes disponibles"
                        onClick={() => this.props.history.push('/salarie/postes_disponibles')}
                        leftIcon={<ActionEventSeatIcon/>}
                    />
                </Drawer>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        open: store.shared.drawer.open,
        entrepriseID: store.entreprise.entreprise_infos.id,
        logoRandomToken: store.entreprise.entreprise_infos.logoRandomToken,
        logo: store.entreprise.entreprise_infos.logo,
        salaries: store.entreprise.entreprise_infos.salaries
    }
}

export default connect(mapStateToProps)(SalarieDrawer);


// WEBPACK FOOTER //
// ./src/components/salarie/SalarieDrawer.js